import identity from 'lodash/identity';
import { actionTypes as types } from '@gcc/configurator';
import priceChangedSuccess from './priceChangedSuccess';
import loadDictionaryTermsSuccess from './loadDictionaryTermsSuccess';
import validateSelectedChoices from './validateSelectedChoices';
import { VALIDATE_SELECTED_CHOICES } from '../../../actions/actionTypes';

const reducers = {
  [types.PRICE_CHANGED_SUCCESS]: priceChangedSuccess,
  [types.LOAD_DICTIONARY_TERMS_SUCCESS]: loadDictionaryTermsSuccess,
  [types.CHOICE_CHANGED_SUCCESS]: (state) => {
    const { options } = state;
    const edgeOption = Object.values(options).find(
      (option) =>
        Array.isArray(option.tags) &&
      option.tags.includes('itemize-label:Edge Style')
    );
    let newChoices = state.choices;
    if (edgeOption) {

      const edgeChoiceIds = edgeOption?.choices || [];

      newChoices = Object.fromEntries(
        Object.entries(state.choices).map(([key, choice]) => {
          if (choice.optionId === edgeOption.id && !edgeChoiceIds.includes(choice.id)) {
            return [key, { ...choice, isSelected: false }];
          }
          return [key, choice];
        })
      );
    }
    return {
      ...state,
      choices: newChoices,
    };
  },
  [VALIDATE_SELECTED_CHOICES]: validateSelectedChoices,

};

export default (action) => (state) => {
  const reduce = reducers[action.type] || identity;

  return reduce(state, action);
};
